import React, { useState, useEffect } from 'react';
import '../App.css';

function Resume() {
    const BASE_URL = process.env.REACT_APP_API_URL;
    const pdfUrl = `${BASE_URL}/docs/document.pdf`;

    return (

        <div>
            <iframe
                className="pdf"
                src={pdfUrl}
                width="800"
                height="500"
                title="PDF Viewer"
            />
        </div>
    );
}

export default Resume;